import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  historic: {
    '& .not-found': {
      width: '100%',
      textAlign: 'center',
      padding: '24px 0',
      fontSize: 14,
      color: theme.palette.primary.light,
    },

    '& .table': {
      marginTop: 12,
    },
  },

  data: {
    '& pre': {
      margin: 0,
      fontSize: 13,
      width: '100%',
      overflow: 'auto',
      background: theme.palette.grey[100],
      padding: 8,
      borderRadius: 4,
      marginTop: 8,
    },
  },

  httpStatus: {
    color: '#ffff',
    padding: '0 0.2rem',
    borderRadius: 4,

    '&.status-504': {
      backgroundColor: theme.palette.error.main,
    },

    '&.status-200': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

export default styles;
